// autosize-textarea.directive.ts
import { Directive, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[autoresizeTextarea]'
})
export class AutosizeTextareaDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLTextAreaElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.resize();
  }

  @HostListener('input')
  onInput() {
    this.resize();
  }

  private resize() {
    const textarea = this.el.nativeElement;
    this.renderer.setStyle(textarea, 'height', 'auto');
    this.renderer.setStyle(textarea, 'height', `${textarea.scrollHeight}px`);
  }
}
